import { render, staticRenderFns } from "./icon-facebook.vue?vue&type=template&id=c3bf67c0&scoped=true&"
import script from "./icon-facebook.vue?vue&type=script&lang=js&"
export * from "./icon-facebook.vue?vue&type=script&lang=js&"
import style0 from "./icon-facebook.vue?vue&type=style&index=0&id=c3bf67c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bf67c0",
  null
  
)

export default component.exports